import Box from '@mui/material/Box';
import CircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import * as React from 'react';

type Props = {
  size?: CircularProgressProps['size'];
  color?: string;
};

/**
 * TODO: Remove default export and fix imports
 *       in the codebase to use named export.
 */
export const LoadingSpinner: React.FC<Props> = ({ size = '30px', color }) => {
  return (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress
        size={size}
        sx={{
          color: (theme) => color || theme.colors.status.blue.main,
        }}
      />
    </Box>
  );
};

export default LoadingSpinner;
